export const SET_SELECTED_ORDERS = 'SET_SELECTED_ORDERS';
export const setSelectedOrders = (selectedOrderIds, entityId = undefined) => ({
  type: SET_SELECTED_ORDERS,
  entityId,
  selectedOrderIds,
});

export const SET_SELECTED_ORDERS_PRE_CHECK = 'SET_SELECTED_ORDERS_PRE_CHECK';
export const setSelectedOrdersPreCheck = (selectedOrderIds, entityId = undefined) => ({
  type: SET_SELECTED_ORDERS_PRE_CHECK,
  entityId,
  selectedOrderIds,
});

export const SELECT_ALL_ORDERS = 'SELECT_ALL_ORDERS';
export const selectAllOrders = (entityId = undefined) => ({
  type: SELECT_ALL_ORDERS,
  entityId,
});

export const CLEAR_SELECTED_ORDERS = 'CLEAR_SELECTED_ORDERS';
export const clearSelectedOrders = () => ({ type: CLEAR_SELECTED_ORDERS });

export const SET_HOLD_UNTIL_DATE = 'SET_HOLD_UNTIL_DATE';
export const setHoldUntilDate = () => ({ type: SET_HOLD_UNTIL_DATE });

export const ADD_OUTDATED_ORDERS = 'ADD_OUTDATED_ORDERS';
export const addOutdatedOrders = (outdatedIds) => ({
  type: ADD_OUTDATED_ORDERS,
  outdatedIds,
});
